import { Box, Container, Divider, Typography, useTheme } from "@mui/material";
import React from "react";
type ErrorPageProps = {
  errorMessage?: string;
  errorCode?: number;
  errorComponent?: React.ReactNode;
};

export const ErrorPage = (props: ErrorPageProps) => {
  const theme = useTheme();
  const textColor = theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.common.black;
  const typographyProps = {
    style: { color: textColor },
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      {props.errorComponent ?? (
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          sx={{ lineHeight: 48, gap: "20px" }}
        >
          <Typography variant="h4" {...typographyProps}>
            {props.errorCode ?? 500}
          </Typography>
          <Divider orientation="vertical" flexItem />
          <Typography variant="h5" {...typographyProps}>
            {props.errorMessage ?? "Something went wrong"}
          </Typography>
        </Box>
      )}
    </Container>
  );
};
